var Vendd = (function (Vendd) {
    'use strict';

    var state = {};
    var getViewModel = function (id, bundleItems) {
        var data = _.extend({}, state);

        var configuration = JSON.parse(data.serviceConfiguration);

        if (id) configuration.LoaderOptions.SkuId = id;
        if (bundleItems) configuration.LoaderOptions.BundleItems = bundleItems;

        function onFailure(response) {
            console.log(response);
        }

        function onSuccess(response) {
            var model = response;
            state.serviceConfiguration = model.Configuration;
            state.path = model.PathChecksum;

            if (id) state.selectedId = id;
            if (bundleItems) state.bundleItems = bundleItems;

            state.minQuantity = (model.MinQuantity === null || model.MinQuantity === '') ? ((model.Quanta !== null) ? model.Quanta : 1) : model.MinQuantity;
            state.maxQuantity = (model.MaxQuantity === null || model.MaxQuantity === '') ? null : model.MaxQuantity;
            state.quanta = (model.Quanta !== null) ? model.Quanta : 1;
            state.qty = state.minQuantity ? state.minQuantity : state.quanta;

            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.Changed(model));
        }

        var queryString = location.search;
        if (queryString !== "") {
            var parameters = queryString.split("&");
            if (queryString.indexOf('sdim') >= 0) {
                for (var i = 0; i < parameters.length; i++) {
                    var pair = parameters[i].split("=");
                    if (pair[0] == 'sdim') {
                        parameters.splice(i, 1);
                    }
                }
                queryString = parameters.join("&");
            }
        }
        var options = {
            url: 'AdapterService.svc/GetData', 
            data: {
                serviceConfiguration: JSON.stringify(configuration)
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    };

    Vendd.Product.Controller = (function () {
        var initialized = false;

        return {
            IsInitialized: function () {
                return !!initialized;
            },
            initState: function (initialState) {
                if (initialized === true) {

                    return state;
                } else {

                    var data = {
                        serviceConfiguration: initialState.serviceConfiguration,
                        selectedId: initialState.selectedId,
                        selectedColorId: initialState.selectedColorId,
                        parentId: initialState.parentId,
                        languageId: initialState.languageId,
                        qty: initialState.qty,

                        path: initialState.path,

                        minQuantity: initialState.minQuantity,
                        maxQuantity: initialState.maxQuantity,
                        quanta: initialState.quanta,
                        bundleItems: initialState.bundleItems, 
                        recipeItems: initialState.recipeItems,
                        comboItems: initialState.comboItems
                    };

                    state = _.extend({}, data);

                    initialized = true;

                    return state;
                };
            },
            getState: function () {
                return state;
            }
        };
    })();

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetQuantity, Vendd.Product, function (envelope) {
        state.qty = envelope.message.data.qty;
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetQuanta, Vendd.Product, function (envelope) {
        state.quanta = envelope.message.data.quanta;
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, Vendd.Product, function (envelope) {

        var skuId = envelope.message.data.id;

        getViewModel(skuId, null);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetBundleItems, Vendd.Product, function (envelope) {

        var bundleItems = envelope.message.data.bundleItems || [];

        getViewModel(null, bundleItems);
    });
    Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetRecipeItems, Vendd.Product, function (envelope) {

        state.recipeItems = envelope.message.data.recipeItems || [];
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetComboItems, Vendd.Product, function (envelope) {

        state.comboItems = envelope.message.data.comboItems || [];
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.Notify, Vendd.Product, function (envelope) {

        var options = {
            url: 'EcomService.svc/SendAvailabityNotification',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.NotifySuccess(response, envelope.sender));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.NotifyFailure(response, envelope.sender));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetReviews, Vendd.Product, function (envelope) {

        var options = {
            url: 'CommonService.svc/GetReviews',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetReviewsSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetReviewsFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.Review, Vendd.Product, function (envelope) {
        var options = {
            url: 'CommonService.svc/ProductReviewSubmit',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.ReviewSuccess(response, envelope.message.data));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.ReviewFailure(response, envelope.message.data));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.ReviewVote, Vendd.Product, function (envelope) {

        var options = {
            url: 'CommonService.svc/ProductReviewHelpfullnessVote',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.ReviewVoteSuccess(response, envelope.message.data.helpfullness.ispositivevote));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.ReviewVoteFailure(response, envelope.message.data.helpfullness.ispositivevote));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetAvailableWarehouses, Vendd.Product, function (envelope) {

        var options = {
            url: 'EcomService.svc/GetProductAvailableWarehouses',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (response.success) {
                var model = response.data && response.data !== "" ? JSON.parse(response.data) : "";
                Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetAvailableWarehousesSuccess(model));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetAvailableWarehousesFailure(response));
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetAvailableWarehousesFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetDeliveryAvailability, Vendd.Product, function (envelope) {

        var options = {
            url: 'EcomService.svc/GetDeliveryAvailabilityData',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (response.success) {
                var model = response.data && response.data !== "" ? JSON.parse(response.data) : "";
                Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetDeliveryAvailabilitySuccess(model));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetDeliveryAvailabilityFailure(response));
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetDeliveryAvailabilityFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetPickUpAvailability, Vendd.Product, function (envelope) {

        var options = {
            url: 'EcomService.svc/GetPickupAvailabilityData',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (response.success) {
                var model = response.data && response.data !== "" ? JSON.parse(response.data) : "";
                Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetPickUpAvailabilitySuccess(model));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetPickUpAvailabilityFailure(response));
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetPickUpAvailabilityFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetReplacedByProducts, Vendd.Product, function (envelope) {
        var options = {
            url: 'api/Product/GetRelatedProducts',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetReplacedByProductsSuccess(response, envelope.message.data));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.GetReplacedByProductsFailure(response, envelope.message.data));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.PdfExport, Vendd.Product, function (envelope) {
        var options = {
            url: 'api/PdfExporter/Generate',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.PdfExportSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Product, new Vendd.Product.Messages.PdfExportFailure(response));
        };

        Vendd.Service.call(options);
    });


    return Vendd;

})(Vendd || {});